import { doc, updateDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db, collections } from '@/lib/firebase';
import { generateEvaluatorDocId } from './utils';
import { EvaluatorInput } from '@/types/evaluator';
import { toast } from 'react-hot-toast';
import { checkAndAutoFinalizeEvaluators } from './autoFinalize';

export async function editEvaluator(
  evaluatorId: string, 
  userId: string, 
  data: EvaluatorInput
): Promise<void> {
  if (!evaluatorId || !userId) {
    throw new Error('Evaluator ID and User ID are required');
  }

  try {
    const docId = generateEvaluatorDocId(evaluatorId, userId);
    const evaluatorRef = doc(db, collections.evaluators, docId);
    
    const evaluatorDoc = await getDoc(evaluatorRef);
    if (!evaluatorDoc.exists()) {
      throw new Error('Evaluator not found');
    }

    const evaluatorData = evaluatorDoc.data();
    if (evaluatorData.userId !== userId) {
      throw new Error('Unauthorized to update this evaluator');
    }

    if (evaluatorData.evaluationCompleted) {
      throw new Error('Cannot update an evaluator who has completed their evaluation');
    }

    await updateDoc(evaluatorRef, {
      firstName: data.firstName.trim(),
      lastName: data.lastName.trim(),
      updatedAt: serverTimestamp()
    });

    // Check for auto-finalization after update
    await checkAndAutoFinalizeEvaluators(userId);

    toast.success('Evaluator updated successfully');
  } catch (error: any) {
    console.error('Error updating evaluator:', error);
    throw new Error(error.message || 'Failed to update evaluator');
  }
}